import { customization } from '@yola/ws-sdk';
import store from 'src/js/store';

const getFontPairVariables = (fontPairId) => {
  const state = store.getState();
  const fontPairConfig = customization.selectors.getFontPair(state, fontPairId);

  const { variables } = fontPairConfig || {};

  return variables || {};
};

export default getFontPairVariables;
